import React from 'react';
import { Modal } from '@consta/uikit/Modal';
import { Button } from '@consta/uikit/Button';
import { Text } from '@consta/uikit/Text';
import { IconAlert } from '@consta/icons/IconAlert';
import { IconClose } from '@consta/icons/IconClose';

interface DeleteModalProps {
    isOpen: boolean;
    entityType: 'field' | 'deposit' | 'section' | 'horizon' | 'bed' | null;
    entityData: any | null;
    error: any | null;
    onClose: () => void;
    onDelete: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
    isOpen,
    entityType,
    entityData,
    error,
    onClose,
    onDelete
}) => {
    if (!entityType || !entityData) return null;

    const getEntityName = () => {
        switch (entityType) {
            case 'field': return 'месторождение';
            case 'deposit': return 'залежь';
            case 'section': return 'участок';
            case 'horizon': return 'горизонт';
            case 'bed': return 'пласт';
            default: return 'объекта';
        }
    };
    
    const getEntityName2 = () => {
        switch (entityType) {
            case 'field': return 'месторождения';
            case 'deposit': return 'залежи';
            case 'section': return 'участка';
            case 'horizon': return 'горизонта';
            case 'bed': return 'пласта';
            default: return 'объекта';
        }
    };

    const getEntityTitle = () => {
        return entityData.name || entityData.code || entityData.uuid;
    };

    const getErrorMessages = () => {
        if (!error) return null;
        
        if (typeof error === 'object' && error !== null) {
            if (Array.isArray(error.data)) {
                return error.data;
            }
            if (Array.isArray(error)) {
                return error;
            }
        }
        
        if (typeof error === 'string') {
            return [error];
        }
        
        return null;
    };

    const errorMessages = getErrorMessages();

    return (
        <Modal
            isOpen={isOpen}
            hasOverlay
            onClickOutside={onClose}
            onEsc={onClose}
        >
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                padding: '24px 24px 20px 24px', // Уменьшен нижний отступ
                gap: '20px',
                minWidth: '400px'
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <Text size="l" weight="semibold">Подтверждение удаления</Text>
                    <Button
                        size="xs"
                        view="clear"
                        iconLeft={IconClose}
                        onClick={onClose}
                        onlyIcon
                    />
                </div>

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px'
                }}>
                    <Text>
                        Вы уверены, что хотите удалить {getEntityName()} <strong>"{getEntityTitle()}"</strong>?
                    </Text>
                    {entityType !== 'bed' && (
                        <Text size="s" view="secondary">
                            Удаление {getEntityName2()} также удалит все дочерние элементы.
                        </Text>
                    )}

                    {errorMessages && errorMessages.length > 0 && (
                        <div style={{
                            marginTop: 4,
                            padding: 12,
                            borderRadius: 8,
                            backgroundColor: 'rgba(255, 0, 0, 0.05)',
                            border: '1px solid #f5222d'
                        }}>
                            {errorMessages.map((errMsg: any, index: any) => (
                                <Text key={index} size="s" view="alert">
                                    {errMsg}
                                </Text>
                            ))}
                        </div>
                    )}
                </div>

                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    gap: '12px',
                    marginTop: '28px' // Минимальный отступ сверху
                }}>
                    <Button
                        size="s"
                        label="Удалить"
                        view="primary"
                        onClick={onDelete}
                    />
                    <Button
                        size="s"
                        label="Отмена"
                        view="ghost"
                        onClick={onClose}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default DeleteModal;